import { render, staticRenderFns } from "./SinglelineAssort.vue?vue&type=template&id=65560bc2&scoped=true&"
import script from "./SinglelineAssort.vue?vue&type=script&lang=js&"
export * from "./SinglelineAssort.vue?vue&type=script&lang=js&"
import style0 from "./SinglelineAssort.vue?vue&type=style&index=0&id=65560bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65560bc2",
  null
  
)

export default component.exports